import { unique, arraysEqual } from '../../utils/collections';
import { prepareUrlColumnFilters } from '../util/data-table';
import { locationEquipmentNameInvalidChars } from '../../redux/constants/names';

export const editableCellProps = { sx: { border: '1px dashed black' } };

// Expects a rich staging point from selector which has references to stagingDevice and promotedPoint
export function stagingPointDiff(sp, equipId) {
  const diff = [];
  if (!sp.published) return diff;
  if (sp.properties?.objectName !== sp.published?.name) diff.push('point name');
  if (sp.pointTypeId !== sp.published?.pointTypeId) diff.push('point type');
  if (sp.rawUnitId !== sp.published?.rawUnitId) diff.push('point unit');
  if (sp.device.name !== sp.device.published?.name) diff.push('device');
  if (
    equipId
      ? sp.equipIds.includes(equipId) !== sp.published?.equipIds?.includes(equipId)
      : !arraysEqual(sp.equipIds, sp.published?.equipIds)
  )
    diff.push('assignments');
  return diff;
}

export function stagingEquipmentDiff(se) {
  const diff = [];
  if (!se.published) return diff;
  if (se.name !== se.published?.name) diff.push('name');
  if (se.equipmentTypeId !== se.published?.equipmentTypeId) diff.push('equipment type');
  if (se.points.some((sp) => !sp.published || stagingPointDiff(sp, se.equipId).length > 0))
    diff.push('points');
  return diff;
}

export function nameValidationMessage(name, originalName, existingNames) {
  if ((name?.length ?? 0) < 3) return 'Name must be at least 3 characters';
  if (existingNames.includes(name) && name !== originalName) return 'Name already in use';
  const invalidChars = locationEquipmentNameInvalidChars(name);
  if (invalidChars) return `${invalidChars.join('')} cannot be used in names`;
  return '';
}

export function computeUnpublishedPointsForEquipment(stagingEquipment) {
  const equipIds = stagingEquipment.map((e) => e.equipId);
  return unique(
    stagingEquipment.flatMap((e) =>
      e.points.filter(
        (p) => !p.published || !equipIds.every((eid) => p.published.equipIds.includes(eid))
      )
    ),
    (p) => p.topic
  );
}

export function buildStagingLink(buildingId, view, filters) {
  return `/staging/${buildingId}/${view}?filterBy=${prepareUrlColumnFilters(filters)}`;
}
